<template>
    <div class="container"  v-title="'认证赛事列表'">
        <Navigation-bar v-scrollShadow="roll < tabTop && roll" :class="{'Bokeh': regulationShow}">
            <div class="nav_title" slot="title" v-if="roll > titleTop" @click="project.show = !project.show">
                <span>{{project.name}}</span>
                <YD-image :src="project.show?'icon/icon_下拉箭头_黑色_向上':'icon/icon_下拉箭头_黑色_向下'"></YD-image>
            </div>
            <YD-image src="icon/icon_search_black" class="search" v-href="'/Competition/EventCertificationSearch'"></YD-image>
            <YD-image src="icon/icon_nav_分享" class="share"
                v-share="{
                    Type: 2,
                    Title: '赛事认证',
                    Text: '多维评估、权威认证、为职工赛事确定官方级别',
                    Link: 'https://m.dazhongyundong.com/app_download/',
                    LinkText: '立即下载APP：',
                    ImgLink: ''
                }" 
                v-if="$appVersion >= '22093000'"
            ></YD-image>
        </Navigation-bar>
        <div class="container_content">
            <div id="EventCertification_list" ref="EventCertification_list" :class="{'Bokeh': regulationShow}">
                <Scroll
                    :scroll="roll"
                    @scrollChange="roll = $event"
                    @scrollEnd="scrollEnd"
                >
                    <div class="ECL_content">
                        <div class="title">
                            <h2>
                                <div v-show="project.name" @click="project.show = !project.show">
                                    <span>{{project.name}}</span>
                                    <YD-image :src="project.show?'icon/icon_下拉箭头_黑色_向上':'icon/icon_下拉箭头_黑色_向下'"></YD-image>
                                </div>
                            </h2>
                            <p class="subTitle">选择运动项目</p>
                        </div>
                        <div class="regulation">
                            <YD-image src="赛事管理办法" @click.native="regulationShow = true"></YD-image>
                        </div>
                        <div class="grade_tab">
                            <div class="grade_tab_fixed" :class="{'fixed':grade.fixed}" v-scrollShadow="roll > tabTop">
                                <ul>
                                    <li @click="selectGrade(null)" :class="{'active':!grade.level}">全部</li>
                                    <li v-for="(item,index) in grade.list" :key="index"
                                        :class="{'active':item == grade.level}"
                                        @click="selectGrade(item)"
                                    >{{item}}级</li>
                                </ul>
                                <div class="num">
                                    <span v-if="loadMore == '无数据'">暂无赛事</span>
                                    <span v-else-if="grade.level">共<i>{{grade.num}}</i>个{{grade.level + '级赛事'}}</span>
                                    <span v-else>共<i>{{grade.num}}</i>个认证赛事</span>
                                </div>
                            </div>
                        </div>
                        <ul class="list">
                            <li v-for="(item,index) in list" :key="index" @click="lookOverCertificate(item.CurrentCertificate.CertificateNumber)">
                                <div class="img">
                                    <div class="no_loading">
                                        <img :_src="item.CertificateFile" onerror="this.parentNode.removeChild(this)">
                                    </div>
                                </div>
                                <div class="info">
                                    <div class="level">
                                        <YD-image :src="`match_detail/${item.CurrentCertificate.Level}级赛事`"></YD-image>
                                    </div>
                                    <div class="match_name">{{item.League.Name}}</div>
                                </div>
                            </li>
                        </ul>
                        <div class="load_more" v-show="loadMore">
                            <img src="@images/no_data/暂无赛事证书@2x.png" v-show="loadMore == '无数据'">
                            <span v-show="loadMore != '无数据'">{{loadMore}}</span>
                        </div>
                    </div>
                </Scroll>
                <button id="ECL_btn" @click="go()">申请认证</button>
                <div class="masking" v-show="project.name && project.show" @click="project.show = false"></div>
                <div id="project_list" v-show="project.name && project.show">
                    <div class="title" v-show="roll <= titleTop">
                        <h2>
                            <div v-show="project.name" @click="project.show = !project.show">
                                <span>{{project.name}}</span>
                                <YD-image :src="project.show?'icon/icon_下拉箭头_黑色_向上':'icon/icon_下拉箭头_黑色_向下'"></YD-image>
                            </div>
                        </h2>
                        <p class="subTitle">选择运动项目</p>
                    </div>
                    <div class="project_list_content">
                        <ul>
                            <li v-for="(item,index) in project.list" :key="index" 
                                :class="{'active': item.Id == project.Id}"
                                @click="projectChange(item)"
                            >
                                {{item.Name}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div id="certificate" v-show="certificateShow"  @click="()=>{certificateShow = false}">
            <div class="certificate_modal">
                <div class="certificate_content" >
                    <YD-image class="medal" :src="'certificate/icon_证书_'+certificateInfo.Level+'级赛事'"></YD-image>
                    <div class="competition_name">
                        <div class="competition_name-content">
                            <p v-for="item in LeagueNames" :key="item">{{item}}</p>
                        </div>
                    </div>
                    <YD-image class="grade" :src="'certificate/文字_'+certificateInfo.Level+'级赛事'"></YD-image>
                    <div class="certificate_serialNumber">证书编号：{{certificateInfo.CertificateNumber}}</div>
                    <div class="certificate_date">{{certificateInfo.IssueDate | dateFormat('yyyy年MM月dd日')}}</div>
                    <div class="certificate_stamp"></div>
                </div>
                <p>
                    <!-- 了解此赛事相关信息点击 <span v-href="'/Match/MatchDetail/'+certificate.Id">赛事详情</span> -->
                </p>
            </div>
        </div>
        <Alert-tip :tipData="alertTip" :tipShow="tipShow" @closeCallback="()=>{tipShow = false}"  @btnCallback="btnCallback"></Alert-tip>
        <div class="regulation_events" v-show="regulationShow">
            <div class="regulation_title">
                <h2>管理办法</h2>
                <p>选择一个项目</p>
            </div>
            <ul>
                <li v-for="(item,index) in project.list" :key="index" 
                    v-show="item.Id > 0"
                    @click="regulationShow = false;$navigation.go('/Rules/CertificationRegulation/'+item.Id);"
                >{{item.Name}}</li>
            </ul>
            <YD-image src="icon/icon_close" class="close" @click.native="regulationShow = false"></YD-image>
        </div>
    </div>
</template>
<script>
import {
    GetEventsFlatedList,
    GetCompanyList,
    GetLeagueCertificateList,
    GetLeagueCertificate
} from "@/api"
import {
    convertSize
} from '@js';
import appInteraction from "@/common/appInteraction"
export default {
    name: 'EventCertificationList',
    data() {
        return {
            roll: 0,//滚动距离
            titleTop: 0,
            tabTop: 0,//等级
            scrollH: 0,
            regulationShow: false,
            project:{
                name: "",
                Id: -1,
                list: [],
                show: false
            },
            grade:{
                level:null,
                list:['A','B','C','D','E'],
                num:0,
                fixed:false
            },
            list:[],
            lastId:0,
            loadMore:'',
            isGetData:true,
            certificateInfo:{},//证书信息
            certificateShow:false,//证书显示
            alertTip:{},
            tipShow:false,
        };
    },
    created(){
        var all = {Id:0,Name:'全部项目'},
            eventsId = this.$route.query.eventsId;
        GetEventsFlatedList().then(data=>{
            if(data.Code == 0){
                var arr = data.EventsList;
                arr.unshift(all);
                this.project.list = arr;
                let eventsInfo = null;
                if(eventsId){
                    eventsInfo = arr.filter(item=>item.Id == eventsId)[0];
                }
                this.projectChange(eventsInfo || all);
            }
        })
    },
    mounted() {
        this.titleTop = convertSize(1.1);
        this.tabTop = convertSize(4.44);
        this.scrollH = this.$refs['EventCertification_list'].offsetHeight;
    },
    watch:{
        roll:function(scroll, oldScroll){
            //管理办法
            if(scroll > this.tabTop){
                this.grade.fixed = true;
            }else{
                this.grade.fixed = false;
            }
            if(scroll > oldScroll){
                this.lazyLoading(scroll);
            }
        },
        'project.show':{
            deep: true,
            handler(newVal){
                if(newVal && this.roll < this.titleTop){
                    this.roll = 0;
                }
            }
        }
    },
    computed: {
        LeagueNames(){
            let {
                LeagueNameByLines,
                LeagueName
            } = this.certificateInfo;
            if(LeagueNameByLines){
                return LeagueNameByLines.split(',');
            }
            return [LeagueName];
        }
    },
    methods: {
        projectChange({Id, Name}){
            if(this.project.Id != Id){
                this.project.Id = Id;
                this.project.name = Name;
                this.grade.level = null;
                this.project.show = false;
                this.getListData(1);
            }
        },
        selectGrade(level){
            if(level != this.grade.level){
                this.grade.level = level;
                this.getListData(1);
            }
        },
        scrollEnd(){
            if(!this.isGetData){ 
                return ;
            }
            this.getListData(2,this.lastId);
        },
        getListData(type,lastId){
            if(type == 1){
                this.lastId = 0;
                lastId = 0;
                this.list = [];
            }
            this.isGetData = false;
            this.loadMore = '数据加载中...';
            GetLeagueCertificateList({
                Continuation: {
                    LastId: lastId,
                    MaxCount: 20
                },
                EventsId: this.project.Id,
                LeagueNameKeyword: this.searchText,
                certificateLevel:this.grade.level
            }).then(data=>{
                this.isGetData = true;
                this.loadMore = '';
                if(data.Code == 0){
                    this.grade.num = data.AllCount;
                    if(!data.ContinuedList || data.ContinuedList.length == 0){
                        if(lastId == 0){
                            this.loadMore = '无数据';
                        }else{
                            this.loadMore = '';
                        }
                        this.isGetData = false;
                    }else{
                        if(lastId == 0){
                            this.list = data.ContinuedList;
                        }else{
                            this.list.push.apply(this.list, data.ContinuedList);
                        }
                        this.lastId = data.ContinuedList[data.ContinuedList.length-1].MainLeagueId;
                        this.$nextTick(function(){
                            this.lazyLoading(this.roll);
                        });
                    }
                }
            }).catch(err=>{
                this.isGetData = true;
                this.loadMore = '';
            })
        },
        lazyLoading(scroll){
            var imgs = document.querySelectorAll('.list .no_loading'); 
            if(imgs.length > 0){
                imgs.forEach((item)=>{
                    let top = item.offsetTop;
                    if(top - scroll < this.scrollH){
                        let src = item.childNodes[0].getAttribute('_src');
                        item.childNodes[0].src = src;
                        item.childNodes[0].removeAttribute('_src');
                        item.childNodes[0].style.display = 'block';
                        item.classList.remove('no_loading');
                    }else{
                        return;
                    }
                })
            }
        },
        go(){
            appInteraction.getUserState().then((loginType)=>{
                this.$store.commit('setUserType',loginType);
                if(loginType == 0){
                    this.alertTip = {
                        title:"未登录",
                        text:"您尚未登录机构账户，请先登录",
                        btnArr:["取消","登录"]
                    }
                    this.tipShow = true;
                }else if(loginType == 1){
                    GetCompanyList({IncludeNotAudited:true}).then((data)=>{
                        if(data.Code == 0){
                            if(data.CompanyList.length == 0){
                                this.alertTip = {
                                    title:"未注册",
                                    text:"您尚未注册机构账户，请前往注册",
                                    btnArr:["取消","前往"]
                                }
                            }else{
                                this.alertTip = {
                                    title:"温馨提示",
                                    text: "赛事认证需由机构账户申请，请切换",
                                    btnArr:["取消","切换"]
                                }
                            }
                            this.tipShow = true;
                        }
                    })
                }else if(loginType == 2){
                    this.$navigation.go('/Competition/EventCertification');
                }
            })
        },
        lookOverCertificate(CertificateNumber){
            if(!CertificateNumber)return;
            GetLeagueCertificate({
                CertificateNumber
            }).then(data=>{
                if(data.Code == 0){
                    this.certificateInfo = data.LeagueCertificate;
                    this.certificateShow = true;
                }
            })
        },
        btnCallback(text){
            this.tipShow = false;
            if(text == "取消"){
            }else if(text == "登录"){
                appInteraction.go2Login(2).then(({Type = 0})=>{
                    if(Type == 1){
                        this.$navigation.go('/Account/CompanyManagement');
                    }else if(Type == 2){
                        this.$navigation.go('/Account/AgencyRegistration');
                    }
                })
            }else if(text == "前往"){
                this.$navigation.go('/Account/AgencyRegistration');
            }else if(text == "切换"){
                this.$navigation.go('/Account/CompanyManagement');
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.nav_title{
    width: auto;
    height: 50px;
    font-size: 36px;
    color: #1B1C1E;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
        width: 32px;
        height: 32px;
        margin-left: 4px;
        margin-top: 1px;
    }
}
.share,
.search{
    width: 48px;
    height: 48px;
    margin-right: -6px;
}
.search + .share{
    margin-left: 30px;
}
#EventCertification_list{
    height: 100%;
    position: relative;
    overflow: hidden;
    .ECL_content{
        padding-bottom: 250px;
    }
    .title{
        width: 100%;
        height: 194px;
        padding: 24px 40px 0;
        box-sizing: border-box;
        &.fixed{
            position: absolute;
            left: 0;
            z-index: 3;
        }
        h2{
            display: inline-block;
            @include line-height(84px);
            font-size: 60px;
            color: #1B1C1E;
            font-weight: 500;
            position: relative;
            img{
                width: 40px;
                margin-left: 12px;
                margin-top: 30px;
            }
        }
        p.subTitle{
            @include line-height(44px);
            font-size: 32px;
            color: #8B8C8D;
            font-weight: 400;
            margin-top: 6px;
        }
    }
    .regulation{
        width: 100%;
        height: 288px;
        display: flex;
        justify-content: center;
        img{
            height: 100%;
        }
    }
    .grade_tab{
        width: 100%;
        height: 168px;
        margin-top: -38px;
        .grade_tab_fixed{
            width: 100%;
            height: 168px;
            padding: 16px 40px 0;
            box-sizing: border-box;
            background: #fff;
            &.fixed{
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
            }
            ul{
                width: 100%;
                height: 72px;
                white-space: nowrap;
                li{
                    width: 104px;
                    @include line-height(72px);
                    font-size: 28px;
                    color: #666666;
                    font-weight: 400;
                    text-align: center;
                    background: #FAFBFA;
                    border-radius: 36px;
                    margin-right: 12px;
                    display: inline-block;
                    vertical-align: middle;
                    &:last-of-type{
                        margin-right: 0;
                    }
                    &.active{
                        color: #FFFFFF;
                        font-weight: 500;
                        background: #1B1C1E;
                    }
                }
            }
            .num{
                height: 72px;
                width: 100%;
                font-size: 26px;
                color: #666666;
                letter-spacing: 0;
                line-height: 40px;
                font-weight: 400;
                margin-top: 8px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                &::after,
                &::before{
                    content:'';
                    flex: 1;
                    border-bottom:1px #E5E5E5 solid;
                }
                span{
                    margin: 0 24px;
                }
                i{
                    font-weight: 500;
                    color: #1B1C1E;
                }
            }
        }
    }
    .list{
        width: 100%;
        padding: 24px 40px 0;
        box-sizing: border-box;
        li{
            width: 324px;
            height: 460px;
            background: #FFFFFF;
            box-shadow: 0px 4px 20px -4px rgba(136,136,136,0.25);
            border-radius: 12px;
            margin-bottom: 16px;
            margin-right: 22px;
            display: inline-block;
            vertical-align: middle;
            overflow: hidden;
            &:nth-of-type(2n){
                margin-right: 0;
            }
            .img{
                width: 100%;
                height: 324px;
                padding: 70px 98px 0 96px;
                box-sizing: border-box;
                background-color: #E4F0F9;
                background-image: url('~@images/证书框@2x.png');
                background-repeat: no-repeat;
                background-size: 100% 100%;
                div,
                img{
                    width: 130px;
                    height: 188px;
                }
                div{
                    background:#D8D8D8;
                }
                img{
                    display: none;
                }
            }
            .info{
                width: 100%;
                padding: 24px 0 0 24px;
                box-sizing: border-box;
                .level{
                    img{
                        width: 122px;
                        height: 40px;
                    }
                }
                .match_name{
                    font-size: 28px;
                    color: #1B1C1E;
                    line-height: 40px;
                    font-weight: 500;
                    margin-top: 8px;
                    @include ellipsis;
                }
            }
        }
    }
    #ECL_btn{
        width: 296px;
        @include line-height(108px);
        background: #1B1C1E;
        box-shadow: 0px 10px 20px 0px rgba(27,28,30,0.25);
        border-radius: 54px;
        font-size: 32px;
        color: #FFFFFF;
        letter-spacing: 6px;
        font-weight: 500;
        position: fixed;
        bottom: 80px;
        left: 50%;
        margin-left: -148px;
    }
    .masking{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.4);
        z-index: 2;
    }
    #project_list{
        width: 100%;
        height: auto;
        background: #FFFFFF;
        border-radius: 0px 0px 40px 40px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 3;
        .project_list_content{
            padding: 24px 0 24px 42px;
            box-sizing: border-box;
            ul{
                display: flex;
                flex-wrap: wrap;
                li{
                    width: 156px;
                    @include line-height(74px);
                    background: #FAFBFA;
                    border-radius: 37px;
                    font-size: 24px;
                    color: #333333;
                    text-align: center;
                    font-weight: 400;
                    margin-right: 16px;
                    margin-bottom: 16px;
                    &.active{
                        background: #1B1C1E;
                        color: #FFFFFF;
                        font-weight: 500;
                    }
                }
            }
        }
    }
}

@include certificate;
.regulation_events{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    background: rgba(0,0,0,0.80);
    .regulation_title{
        width: 100%;
        position: absolute;
        top: 10.6%;
        left: 0;
        h2{
            font-size: 60px;
            color: #FFFFFF;
            font-weight: 500;
            line-height: 84px;
            text-align: center;
        }
        p{
            font-size: 32px;
            color: #999999;
            line-height: 44px;
            font-weight: 400;
            text-align: center;
            margin-top: 6px;
        }
    }
    ul{
        width: 100%;
        height: auto;
        padding-left: 36px;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        position: absolute;
        top: 26.2%;
        left: 0;
        li{
            width: 156px;
            @include line-height(74px);
            background: #FFFFFF;
            border-radius: 37px;
            font-size: 24px;
            color: #333333;
            text-align: center;
            font-weight: 400;
            margin-right: 16px;
            margin-bottom: 16px;
        }
    }
    .close{
        width: 100px;
        height: 100px;
        position: absolute;
        bottom: calc(var(--safe-area-inset-bottom) + 40px);
        left: 324px;
    }
}
</style>